import { api } from "./api";

export const timingState = () =>
    api.get(`/timing/state`).then((r) => r.data);

export const timingIngest = (season = null) =>
    api.post(`/timing/ingest`, null, { params: season ? { season } : {} }).then((r) => r.data);

export const timingSearchPlayers = ({ q = "", position = null, team = null, limit = 100 } = {}) =>
    api
        .get(`/timing/players`, { params: {
            ...(q ? { q } : {}),
            ...(position ? { position } : {}),
            ...(team ? { team } : {}),
            limit,
        } })
        .then((r) => r.data);

export const timingKnownTeams = () =>
    api.get(`/timing/teams`).then((r) => r.data);

export const timingPlayerDetail = (playerKey, { seasons = null, gwFrom = null, gwTo = null } = {}) =>
    api
        .get(`/timing/player/${encodeURIComponent(playerKey)}`, {
            params: {
                ...(seasons ? { seasons: seasons.join(",") } : {}),
                ...(gwFrom ? { gw_from: gwFrom } : {}),
                ...(gwTo ? { gw_to: gwTo } : {}),
            },
        })
        .then((r) => r.data);

export const timingPlayerOpponents = (playerKey, { seasons = null, minGames = 2 } = {}) =>
    api
        .get(`/timing/player/${encodeURIComponent(playerKey)}/opponents`, {
            params: {
                ...(seasons ? { seasons: seasons.join(",") } : {}),
                min_games: minGames,
            },
        })
        .then((r) => r.data);

export const timingCompare = (playerKeys, { seasons = null } = {}) =>
    api
        .get(`/timing/compare`, {
            params: {
                ids: playerKeys.join(","),
                ...(seasons ? { seasons: seasons.join(",") } : {}),
            },
        })
        .then((r) => r.data);

export const timingRecommendConsistent = (params = {}) =>
    api.get(`/timing/recommendations/consistent`, { params }).then((r) => r.data);

export const timingRecommendExplosive = (params = {}) =>
    api.get(`/timing/recommendations/explosive`, { params }).then((r) => r.data);

export const timingRecommendValue = (params = {}) =>
    api.get(`/timing/recommendations/value`, { params }).then((r) => r.data);

export const timingRecommendValueNew = (params = {}) =>
    api.get(`/timing/recommendations/value-new-price`, { params }).then((r) => r.data);

export const timingRecommendPeriod = (period, params = {}) =>
    api
        .get(`/timing/recommendations/period`, { params: { period, ...params } })
        .then((r) => r.data);


// --- Transfers (confirmed, summer 2026 window) ------------------------
export const timingTransfers = ({ refresh = false } = {}) =>
    api.get(`/timing/transfers`, { params: refresh ? { refresh: true } : {} }).then((r) => r.data);

export const timingTransferMark = (rowId, important) =>
    api.post(`/timing/transfers/mark`, { row_id: rowId, important }).then((r) => r.data);


// --- Hauls (10+ point GWs) --------------------------------------------
export const timingHauls = ({ q = "", position = "", team = "", minGames = 50, sort = "hauls" } = {}) =>
    api.get(`/timing/hauls`, { params: { ...(q && { q }), ...(position && { position }), ...(team && { team }), min_games: minGames, sort } }).then((r) => r.data);

export const timingHaulsDetail = (playerKey) =>
    api.get(`/timing/hauls/${encodeURIComponent(playerKey)}`).then((r) => r.data);


// --- FDR performance (points vs opponent difficulty) ------------------
export const timingFdrPerf = ({ q = "", position = "", team = "", minGames = 50, sort = "hard", onlyActive = true } = {}) =>
    api.get(`/timing/fdr-perf`, { params: { ...(q && { q }), ...(position && { position }), ...(team && { team }), min_games: minGames, sort, only_active: onlyActive } }).then((r) => r.data);

export const timingFdrPerfDetail = (playerKey) =>
    api.get(`/timing/fdr-perf/${encodeURIComponent(playerKey)}`).then((r) => r.data);

export const timingRecommendFdrAbility = (params = {}) =>
    api.get(`/timing/recommendations/fdr-ability`, { params }).then((r) => r.data);


// --- Admin: duplicate detection & merge -------------------------------
export const timingListDuplicates = () =>
    api.get(`/timing/admin/duplicates`).then((r) => r.data);

export const timingMergeDuplicate = ({ a_key, b_key, canonical_key }) =>
    api.post(`/timing/admin/duplicates/merge`, { a_key, b_key, canonical_key }).then((r) => r.data);

export const timingRejectDuplicate = ({ a_key, b_key }) =>
    api.post(`/timing/admin/duplicates/reject`, { a_key, b_key }).then((r) => r.data);

export const timingListAliases = () =>
    api.get(`/timing/admin/aliases`).then((r) => r.data);
